import React from 'react';

import { IconStyle } from './styles.module';

import { CallOut } from './images/call-out';
import { CallIn } from './images/call-in';
import { Call } from './images/call';
import { CloseRound } from './images/close';
import { Member } from './images/member';
import { Silver } from './images/silver';
import { Edit } from './images/edit';
import { Burger } from './images/burger';
import { ArrowUp } from './images/arrow-up';
import { ArrowDown } from './images/arrow-down';
import { Bag } from './images/bag';
import { Note } from './images/note';
import { NoteDot } from './images/note-dot';
import { More } from './images/more';
import { Search } from './images/search';
import { AddFilled } from './images/add-filled';
import { Settings } from './images/settings';
import { StatusPic } from './images/status-pic';
import { Backward } from './images/backward';
import { AddRoundFilled } from './images/add-round-filled';
import { PaginateLeft } from './images/paginate-left';
import { PaginateRight } from './images/paginate-right';
import { Dialog } from './images/dialog'
import { CallSilent } from './images/call-silent';
import { CheckMark } from './images/checkmark';
import { Unavailable } from './images/unavailable';
import { Attach } from './images/attach';
import { Check } from './images/check';



interface IIconProps {
    classWrapper?    : string;
    className?       : string;
    icon             : string;
    color?           : string;
    width?           : string;
    height?          : string;
    onClick?(e?:any) : void;
};

interface IIconState {};

export class Icon extends React.Component<IIconProps, IIconState> {

    icons = {
        'call-out'         : CallOut,
        'call-in'          : CallIn,
        'call'             : Call,
        'close'            : CloseRound,
        'edit'             : Edit,
        'member'           : Member,
        'silver'           : Silver,
        'burger'           : Burger,
        'arrow-up'         : ArrowUp,
        'arrow-down'       : ArrowDown,
        'bag'              : Bag,
        'note'             : Note,
        'note-dot'         : NoteDot,
        'more'             : More,
        'search'           : Search,
        'add-filled'       : AddFilled,
        'add-round-filled' : AddRoundFilled,
        'settings'         : Settings,
        'status-pic'       : StatusPic,
        'backward'         : Backward,
        'paginate-left'    : PaginateLeft,
        'paginate-right'   : PaginateRight,
        'dialog'           : Dialog,
        'call-silent'      : CallSilent,
        'checkmark'        : CheckMark,
        'unavailable'      : Unavailable,
        'attach'           : Attach,
        'check'            : Check,
    } as any;

    render() {
        const TargetIcon = this.icons[this.props.icon];

        return (
            <IconStyle 
                className={`${this.props.classWrapper ? this.props.classWrapper : ''}`}
                onClick={(e) => this.props.onClick && this.props.onClick(e)}
            >
                <div className={`icon ${this.props.className ? this.props.className : ''}`}>
                    <TargetIcon 
                        color={this.props.color || null} 
                        width={this.props.width || null} 
                        height={this.props.height || null} />
                </div>
            </IconStyle>
        )
    }
}
